import React from 'react'

import introStyles from '../styles/components/index.module.scss'

const contactPage = () => {
    return (
        <div className = {introStyles.conclusionBlock}>
                        <div className = {introStyles.conclusionDetails}>
                            <a className = {introStyles.contactButtonLink} href = "/404" rel="noreferrer" target="_blank"><div className = {introStyles.contactButton}>Newsletter</div></a>
                        </div>
                    </div>
    )
}

export default contactPage